import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchClaimItems = createProvider(api.fetchClaimItems).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Fetch claim items aborted');
  } else {
    console.error('Fetch claim items was failed:', error);
  }
  throw error;
});
